// extracted by mini-css-extract-plugin
export default {"root":"QuestionBody_root__HFztj","info":"QuestionBody_info__EkPv6"};